import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ProductosFinancierosService } from '../../../services/productos-financieros.service';
import { HelpersService } from '../../../services/tools/helpers.service';
declare var $;
@Component({
  selector: 'app-registrar-producto-financiero',
  templateUrl: './registrar-producto-financiero.component.html',
  styleUrls: ['./registrar-producto-financiero.component.scss']
})
export class RegistrarProductoFinancieroComponent implements OnInit {

  public isUpdate: boolean = false;
  public producto: any = {};
  public errors:any = {};
  public processing: boolean = false;
  public tipo_fondeador: any = {id:null};
  public tipoFondeadorOpc: any[] = [];
  public fondeadorPorDefecto: string = "";
  //Bandera ahorrador
  public isAhorrador: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<RegistrarProductoFinancieroComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any,
    private service: ProductosFinancierosService,
    private helperService: HelpersService
  ) { }

  ngOnInit() {
    //Obtenemos el valor de la bandera para saber si se va a actualizar o agregar
    this.isUpdate=this.data.flag;
    console.log("Flag: ", this.isUpdate);
    this.producto = this.service.getDefaultSchedule();
    this.addTipoFondeador();
    if(this.isUpdate){
      this.producto = this.data.producto;
      this.selectTipoFondeador(this.producto.tipo_fondeador);
      if(this.producto.tipo_fondeador === "Ahorrador"){
        this.isAhorrador = true;
      }else{
        this.isAhorrador = false;
      }
    }else{
      this.producto = {};
    }
    console.log("Data update: ", this.producto);
  }

  public close(){
    this.dialogRef.close({update:false})
  }

  //Cambiar select del tipo de fondeador
  private selectTipoFondeador(tipoSelect){
    let component = this;
    this.tipoFondeadorOpc.forEach(function(tipo) {
      if(tipo.nombre === tipoSelect){
        component.tipo_fondeador = tipo;
      }
    });
  }

  public accept(){
    this.errors = [];
    
    //Tipo fondeador
    if(this.tipo_fondeador.id === null){
      this.producto.tipo_fondeador = "";
    }
    else
    {
      this.producto.tipo_fondeador = this.tipo_fondeador.nombre;
    }

    if(this.producto.tipo_fondeador === "Inversionista"){
      this.producto.periodicidad = null;
    }
    if(this.producto.iva == 0){
      //console.log("entro al if del iva");
      this.producto.iva = "0";
    }
    //Validar
    this.errors = this.service.validate(this.producto);
    
    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    
    if(this.isUpdate){
      console.log("Entro a aceptar validación");
      this.updateProducto();
    }else {
      this.addProducto();
    }
  }

  public addTipoFondeador(){
    this.tipoFondeadorOpc = [{ id: 1, nombre: "Ahorrador"}, {id: 2, nombre: "Inversionista"}];
    
    if (this.tipoFondeadorOpc.length>1){
      this.fondeadorPorDefecto = "Seleccione";
    } else if(this.tipoFondeadorOpc.length>0){
      this.tipo_fondeador =  this.tipoFondeadorOpc[0];
    }
    
  }

  //Validar el porcentaje de las tasas
  public validarCampos(tipo: number){
    switch(tipo){
      case 1:
        if(this.producto.tasa < 0){
          alert("No se permiten valores negativos");
          this.producto.tasa = "";
        }else if(this.producto.tasa > 100){
          alert("No se permite un porcentaje mayor a 100");
          this.producto.tasa = "";
        }
        break;
      case 2:
        if(this.producto.penalizacion < 0){
          alert("No se permiten valores negativos");
          this.producto.penalizacion = "";
        }else if(this.producto.penalizacion > 100){
          alert("No se permite un porcentaje mayor a 100");
          this.producto.penalizacion = "";
        }
        break;
      case 3:
        if(this.producto.periodicidad < 0){
          alert("No se permiten valores negativos");
          this.producto.periodicidad = "";
        }
        break;
      case 4:
        if(this.producto.plazo < 0){
          alert("No se permiten valores negativos");
          this.producto.plazo = "";
        }
        break;
      case 5:
        if(this.producto.iva < 0){
          alert("No se permiten valores negativos");
          this.producto.iva = "";
        }else if(this.producto.iva > 100){
          alert("No se permite un porcentaje mayor a 100");
          this.producto.iva = "";
        }
        break;
    }
  }
  //Función para registrar producto financiero
  public addProducto(){
     //console.log("Datos Ben: ",this.beneficiario);
     this.service.registrarProductoFinanciero(this.producto)
     .subscribe(response => {
       const datosProducto = response.json();

       console.log("Resp service producto: ",datosProducto);

       this.processing = false;
       if (datosProducto.success) {
         this.helperService.notification('Producto agregado', 'Se ha creado exitosamente el producto financiero', 'success');
         this.dialogRef.close();
         setTimeout(() => {window.location.reload()},3000);
         
       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }
       
       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
     });
  }

  public updateProducto(){
    console.log("Se va actualizar: ",this.producto);
    this.service.updateProducto(this.producto.id, this.producto)
      .subscribe(response => {
        const respuesta = response.json();
        if (respuesta.success) {
          this.helperService.notification('Producto actualizado', 'Se ha actualizado exitosamente', 'success');
          //Poner dentro del success response
          this.dialogRef.close({update:true, new: this.producto});
        }
      }, error => {
        if(error.status == 400) {
          this.showServicesErrors(error.json().content);
        }else{
          this.dialogRef.close({update:false});
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  public tipoFondeadorChanged(tipoFondeador){
    this.tipo_fondeador = tipoFondeador;
    console.log("Tipo : ",this.tipo_fondeador);
    if(this.tipo_fondeador.nombre === 'Ahorrador'){
      this.isAhorrador = true;
    }else{
      this.isAhorrador = false;
    }
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/productos-financieros/registrar-producto-financiero/registrar-producto-financiero.component.ts